import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import {
    DashboardResourceService
} from "libraries/service/resources/dashboard/dashboard-resource.service";
import { SearchParameterService } from "app_dashboard/service/search-parameter.service";
import { Wording } from "app_dashboard/pages/dashboard/dashboard-page.component";
import { GenericGraph } from "../generic-graph/generic-graph.directive";
import { NotificationType } from "../../../../../libraries/interfaces/INotification";
import { LocalizedPipe } from "../../../../../libraries/pipes/localized/localized.pipe";
@Component({
    selector: 'multiple-bar-graph',
    template: `
        <notification [type]="notificationType" *ngIf="displayError">
            {{error}}
        </notification>
        <div [id]="id" class="full">

        </div>
    `,
    styles: [`
        .full {
            width: 100%;
            height: 100%;
        }
    `],
})
export class MultipleBarGraphComponent extends GenericGraph implements OnInit, AfterViewInit, OnDestroy {

    private wording: Wording = new Wording();

    constructor(
        public searchParameterService: SearchParameterService,
        public dashboardResource: DashboardResourceService,
        public localizedPipe: LocalizedPipe
    ) {
        super(searchParameterService, dashboardResource, localizedPipe);
    }

    protected draw(data: any): void {
        this.displayError = false;
        this.chart.clear();
        if (data.series) {
            let option = {
                xAxis: {
                    type: 'category',
                    data: data.col,
                    name: this.xAxis,
                    nameLocation: 'center',
                    nameGap: 30,
                    axisLabel: {
                        show: true,
                    }
                },
                yAxis: {
                    type: 'value',
                    name: this.yAxis,
                    nameGap: 0,
                    nameTextStyle: {
                        align: "left"
                    },
                    axisLabel: {
                        show: true,
                    }
                },
                series: data.series,
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    },
                },
                legend: {
                    show: false,
                    orient: "horizontal",
                    top: 20
                },
                title: {
                    text: this.title,
                    textStyle: {
                        fontSize: 15,
                    },
                }
            };
            if (data.series?.length > 1) {
                option.legend.show = true;
            }
            if (this.config.displayY !== undefined && !this.config.displayY) {
                option.yAxis.axisLabel.show = false;
            }
            if (this.config.displayX !== undefined && !this.config.displayX) {
                option.xAxis.axisLabel.show = false;
            }
            this.chart.setOption(option);
        } else {
            this.chart.clear();
            this.displayError = true;
            this.notificationType = NotificationType.Info;
            this.error = this.wording.noData;
        }
    }
}
